














































import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";


@Component
export default class BaseTLTreeView extends Vue {

	@Prop({ type: String, required: false, default: "" }) detailRoute?: string; //route na detail
	@Prop({ type: String, required: false, default: "" }) returnRoute?: string; //route navratu
	@Prop({ type: String, required: false, default: "onlyView" }) typeView?: string; //typ stromu - edit, 

	@Prop({ type: String, required: false, default: "Název" }) label?: string; //hlavní popis
	@Prop({ required: true }) itemData: any;

	@Prop({ type: Boolean, required: false, default: false }) isOpen?: boolean;

	@Prop({ type: Boolean, required: false, default: false }) canDelete?: boolean; //zobrazit tlačitko delete
	@Prop({ type: Boolean, required: false, default: false }) canCreate?: boolean; //zobrazit tlačitko novy
	@Prop({ type: Boolean, required: false, default: false }) canUpdate?: boolean; //zobrazit tlačitko update
	@Prop({ type: Boolean, required: false, default: false }) canRead?: boolean; //zobrazit tlačitko info

	editNode() {		
	}

	makeFolder(item: any) {
		Vue.set(item, 'children', [])
		this.addItem(item)
	};

	removeItem(item: any) {

	}

	addItem(item: any) {
		if (item.children == undefined) {
			Vue.set(item, 'children', []);
		}
		item.children.push({
			name: 'nova položka'
		})
	};

	//načtení stylu
	get inputClass() {
		return {

			"label-design-head": true
		};
	}


}
